import { render, staticRenderFns } from "./ProcedureSelect.vue?vue&type=template&id=0f9bd20b&lang=pug"
import script from "./ProcedureSelect.vue?vue&type=script&lang=js"
export * from "./ProcedureSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports